export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "/signup";
//
export const APP = process.env.REACT_APP_APP || null;
// External Urls
export const API_URL = process.env.REACT_APP_API_URL || null;
export const API_KEY = process.env.REACT_APP_API_KEY || null;
// Session
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || null;

export const ORGS = {
    fa: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_FA || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: ["bank_transfer"],
        hasChannels: true,
        showReferral: false,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 3.00,
            digital_recorder_plus: 6.00,
        },
    },
    uptv: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_UPTV || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: [ "credit_card", "other"],
        hasChannels: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 6.00,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 6.00,
                    default: true,
                }
            ]
        },
    },
    cogir: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_COGIR || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: [ "credit_card", "other"],
        hasChannels: false,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 5.00,
            decoders: [
                {
                    "value": "LOCATION",
                    "label": "Location",
                    "price": 6.00,
                    "default": true,
                }
            ]
        },
    },
    sjm: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_SJM || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: ["credit_card", "other"],
        hasChannels: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 6.00,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 6.00,
                    default: true,
                },
                {
                    value: "ACHAT",
                    label: "Achat",
                    price: 129.95,
                    default: false,
                }
            ]
        },
    },
    ispx: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_ISPX || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: ["bank_transfer", "credit_card", "other"],
        hasChannels: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 3.00,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 5.00,
                    default: true,
                },
                {
                    value: "ACHAT",
                    label: "Achat",
                    price: 129.95,
                    default: false,
                }
            ]
        },
    },
    centretess: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_CENTRETESS || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: ["credit_card", "other"],
        hasChannels: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 6.00,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 6.00,
                    default: true,
                },
                {
                    value: "ACHAT",
                    label: "Achat",
                    price: 129.95,
                    default: false,
                }
            ]
        },
    },
    satelcom: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_CENTRETESS || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: ["credit_card", "other"],
        hasChannels: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 6.00,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 6.00,
                    default: true,
                },
                {
                    value: "ACHAT",
                    label: "Achat",
                    price: 129.95,
                    default: false,
                }
            ]
        },
    },
    ctal: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_CTAL || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: [],
        hasChannels: true,
        hasSectionTwoCustom: true,
        defPrices: {
            unlimited_can_usa_long_distance: 6.75,
            digital_recorder: 2.50,
            digital_recorder_hours: 150,
            decoders: [
                {
                    value: "LOCATION",
                    label: "Location",
                    price: 6.00,
                    default: true,
                },
            ]
        }
    },
    tflm: {
        channelChooseUrl: process.env.REACT_APP_CHANNEL_CHOOSE_URL_TFLM || process.env.REACT_APP_CHANNEL_CHOOSE_URL || null,
        payment_methods: [],
        hasChannels: true,
        hideSectionTwo: true,
        defPrices: {
            unlimited_can_usa_long_distance: 0,
            digital_recorder: 4.95,
            digital_recorder_hours: 150,
            digital_recorder_plus: 7.95,
            digital_recorder_plus_hours: 300,
        }
    },
};

